import { render, staticRenderFns } from "./FieldContent.vue?vue&type=template&id=38134ad6"
import script from "./FieldContent.vue?vue&type=script&lang=js"
export * from "./FieldContent.vue?vue&type=script&lang=js"
import style0 from "./FieldContent.vue?vue&type=style&index=0&id=38134ad6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports